// Which homepage arm this visit got (landingExperiment.ts). nginx serves
// either /index.html or /home-paths/index.html at "/". The paths file was
// built for the /home-paths/ page, so on load Gatsby would see that its page
// path differs from the address and switch the address to /home-paths/
// (cache-dir/production-app.js). `adoptServedHomeArm` runs first, in
// onClientEntry: it keeps Gatsby on "/" and remembers the arm, and the "/"
// page renders that arm (components/HomePage.tsx), which matches the served
// HTML, so hydration lines up.

export type HomeArm = "canvas" | "paths";

export const HOME_PATHS_PAGE_PATH = "/home-paths/";

let servedArm: HomeArm | null = null;

/** Call once in onClientEntry, before Gatsby compares page paths. */
export function adoptServedHomeArm(): void {
  if (typeof window === "undefined") return;
  const w = window as Window & { pagePath?: string };
  if (w.pagePath === HOME_PATHS_PAGE_PATH && window.location.pathname === "/") {
    w.pagePath = "/";
    servedArm = "paths";
  }
}

/** The arm "/" should render: "canvas" unless nginx served the paths page. */
export function servedHomeArm(): HomeArm {
  return servedArm ?? "canvas";
}
